// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__JGk_2"};